import { useState } from "react";
import { Link } from "react-router-dom";

import ROUTES from "../routes";

function Sidebar() {
    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenu = (menuName) => {
        setOpenMenu((prev) => (prev === menuName ? null : menuName));
    };

    const handleDashboardClick = () => {
        setOpenMenu(null);
    };

    return (
        <div className="deznav">
            <div className="deznav-scroll">
                <ul className="metismenu" id="menu">

                    <li>
                        <Link to={ROUTES.DASHBOARD} onClick={handleDashboardClick}>
                            <i className="flaticon-dashboard-1"></i>
                            <span className="nav-text">Dashboard</span>
                        </Link>
                    </li>

                    <li className={openMenu === "projects" ? "mm-active" : ""}>
                        <a
                            className="has-arrow ai-icon"
                            href="#/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu("projects");
                            }}
                            aria-expanded={openMenu === "projects" ? "true" : "false"}
                        >
                            <i className="flaticon-381-layer-1"></i>
                            <span className="nav-text">Projects</span>
                        </a>
                        <ul
                            className="submenu"
                            style={{ display: openMenu === "projects" ? "block" : "none" }}
                        >
                            <li><Link to={ROUTES.ADD_PROJECT}>Add New</Link></li>
                            <li><Link to={ROUTES.PROJECTS}>List</Link></li>
                        </ul>
                    </li>

                    <li className={openMenu === "space-cards" ? "mm-active" : ""}>
                        <a
                            className="has-arrow ai-icon"
                            href="#/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu("space-cards");
                            }}
                            aria-expanded={openMenu === "space-cards" ? "true" : "false"}
                        >
                            <i className="flaticon-381-layer-1"></i>
                            <span className="nav-text">Space Cards</span>
                        </a>
                        <ul
                            className="submenu"
                            style={{ display: openMenu === "space-cards" ? "block" : "none" }}
                        >
                            <li><Link to={ROUTES.ADD_SPACECARD}>Add New</Link></li>
                            <li><Link to={ROUTES.SPACECARDS}>List</Link></li>
                        </ul>
                    </li>

                    <li className={openMenu === "seo" ? "mm-active" : ""}>
                        <a
                            className="has-arrow ai-icon"
                            href="#/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu("seo");
                            }}
                            aria-expanded={openMenu === "seo" ? "true" : "false"}
                        >
                            <i className="flaticon-381-layer-1"></i>
                            <span className="nav-text">SEO</span>
                        </a>
                        <ul
                            className="submenu"
                            style={{ display: openMenu === "seo" ? "block" : "none" }}
                        >
                            <li><Link to={ROUTES.ADD_SEO}>Add New</Link></li>
                            <li><Link to={ROUTES.SEO}>List</Link></li>
                        </ul>
                    </li>


                    <li className={openMenu === "cta" ? "mm-active" : ""}>
                        <a
                            className="has-arrow ai-icon"
                            href="#/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu("cta");
                            }}
                            aria-expanded={openMenu === "cta" ? "true" : "false"}
                        >
                            <i className="flaticon-381-layer-1"></i>
                            <span className="nav-text">CTA</span>
                        </a>
                        <ul
                            className="submenu"
                            style={{ display: openMenu === "cta" ? "block" : "none" }}
                        >
                            <li><Link to={ROUTES.CTA_CONTACT_US}>Contact Us</Link></li>
                            <li><Link to={ROUTES.CTA_CAREER}>Career</Link></li>
                        </ul>
                    </li>

                    <li className={openMenu === "cms" ? "mm-active" : ""}>
                        <a
                            className="has-arrow ai-icon"
                            href="#/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu("cms");
                            }}
                            aria-expanded={openMenu === "cms" ? "true" : "false"}
                        >
                            <i className="flaticon-form-1"></i>
                            <span className="nav-text">CMS</span>
                        </a>
                        <ul
                            className="submenu"
                            style={{ display: openMenu === "cms" ? "block" : "none" }}
                        >
                            <li><Link to={`/cms/home`}>Home</Link></li>
                            <li><Link to={`/cms/about`}>About</Link></li>
                            <li><Link to={`/cms/contact`}>Contact</Link></li>
                            <li><Link to={`/cms/career`}>Career</Link></li>
                            <li><Link to={`/cms/project`}>Project</Link></li>
                        </ul>
                    </li>

                </ul>
            </div>
        </div>
    );
}

export default Sidebar;
